export const iconFontAwesomeScienceCircleRadiation = (
	<i className="fa-solid fa-circle-radiation"></i>
);
